import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import ICONS from '../../../../../../enums/icons';
import { Button } from '../../../../../ui/button';
import {
    ModalClose,
    ModalFooter
} from '../../../../../ui/modal';
import PropTypes from 'prop-types';

const FooterConfirmation = ({
    onValidation,
    isSubmitDisabled,
    entityClose = 'button.no',
    entityValidate = 'button.yes',
    iconClose = ICONS.CLOSE,
    iconValidate = ICONS.VALIDATE
}) => {
    return (
        <ModalFooter>
            {isSubmitDisabled && <Spinner className='form-spinner' />}
            <ModalClose asChild>
                <Button
                    type='submit'
                    variant='secondary'
                    entity={entityClose}
                    icon={iconClose}
                />
            </ModalClose>
            <Button
                type='submit'
                variant='primary'
                entity={entityValidate}
                icon={iconValidate}
                onClick={onValidation}
                disabled={isSubmitDisabled}
            />
        </ModalFooter>
    );
};

FooterConfirmation.propTypes = {
    onValidation: PropTypes.func.isRequired,
    isSubmitDisabled: PropTypes.bool
};

export default FooterConfirmation;